import { ListItemIcon, ListItemText } from "@mui/material";
import * as React from "react";
import {useNavigate} from "react-router-dom";


import ListItemButton from "@mui/material/ListItemButton";


type SideBarItemProp = {
	label: React.ReactNode;
	href?: string;
	icon?: React.ReactElement;
	onClick?: () => void;
	divider?: boolean;
	disabled?: boolean;
};

export default function SideBarItem(props: SideBarItemProp) {
	const navigate = useNavigate();
	const clickHandler = (event: any) => {
		if (props.onClick) {
			props.onClick();
		} else if (props.href) {
			let newWindowReq = false;
			if (event.button == 1) {
				newWindowReq = true;
			}
			const url = props.href;
			if (newWindowReq) {
				window.open(url);
			} else {
				navigate(props.href);
			}

		}
	};
	return (
        <>
            {props.href && (
				<ListItemButton
                    divider={props.divider}
                    disabled={props.disabled}
                    onMouseUp={(event) => clickHandler(event)}
                    onClick={(event) => clickHandler(event)}>
					{props.icon && <ListItemIcon sx={{minWidth: 0}}>{props.icon}</ListItemIcon>}
					<ListItemText sx={{paddingLeft: 1}} className={"sidebar-item"} primary={props.label}/>
				</ListItemButton>
			)}
            {!props.href && (
				<ListItemButton
                    divider={props.divider}
                    disabled={props.disabled}
                    onMouseUp={(event) => clickHandler(event)}
                    onClick={(event) => clickHandler(event)}>
					{props.icon && <ListItemIcon sx={{minWidth: 0}}>{props.icon}</ListItemIcon>}
					<ListItemText sx={{paddingLeft: 1}} className={"sidebar-item"} primary={props.label}/>
				</ListItemButton>
			)}
        </>
    );
}
